module.exports = __webpack_public_path__ + "static/optimize-your-meta-product-catalog-5dfc6383167180ba96761d1183d0d5e8.jpg";